module.exports = __webpack_public_path__ + "media/images/emblems/Clarmont-coat_of_arms-8b9602c6a352e19b334aa1efb7c93c54.svg";